export default __webpack_public_path__ + "static/media/Others.96669738.png";